import { useNavigate } from 'react-router-dom';

import { UseAlert } from '../../../presentation/hook/AlertHook';

import { ClinicUseCase } from '../../../data/useCase/ClinicUseCase';

import { PublicRoutes } from '../../../main/constant/RouteConstant';

import { maskUtils } from '../../../main/helper/maskHelper';

import CriarClinicaPage from '../../../presentation/page/createClinic/CreateClinicaPage';
import MessageConstant from '../../../main/constant/MessageConstant';
import { HttpStatusCodeEnum } from '../../enums/HttpStatusCodeEnum';
import { AddressUseCase } from '../../../data/useCase/AddressUseCase';
import { useState } from 'react';
import { EndpointsConstant } from '../../../main/constant/EndpointConstant';

/**
 * CreateClinicPageDomain - regra de negocio de clinica
 * @constructor
 */
export const CreateClinicPageDomain: React.FC = () => {
  /**
   * Alertas
   */
  const { showAlert } = UseAlert();

  /**
   * navegacao da url
   */
  let navigate = useNavigate();

  /**
   * endpoint
   */
  const ENDPOINT_CLINIC = EndpointsConstant.clinic;

  /**
   * createClinic
   * @param params
   */
  const createClinic = async (params: any) => {
    const model = {
      name: params.name,
      status: 'A',
      tradeName: params.accountType === 'J' ? params.tradeName : params.name,
      accountType: params.accountType,
      document_CNPJ: params.accountType === 'J' ? params.document_CNPJ : '',
      document_CPF: params.accountType !== 'J' ? params.document_CPF : '',
      contact_Phone: maskUtils.somenteNumeros(params.contact_Phone),
      contact_Email: params.contact_Email,
      address_ZipCode: maskUtils.somenteNumeros(params.address_ZipCode),
      address_Street: params.address_Street,
      address_Number: params.address_Number,
      address_Complement: params.address_Complement,
      address_Neighborhood: params.address_Neighborhood,
      address_City: params.address_City,
      address_State: params.address_State,
      address_Country: 'BR',
      responsible_Name: params.accountType === 'J' ? params.responsible_Name : params.name,
      responsible_Email: params.accountType === 'J' ? params.responsible_Email : params.contact_Email,
      responsible_Document_RG: params.accountType === 'J' ? params.responsible_Document_RG : '',
      responsible_Document_CRO: params.responsible_Document_CRO,
      responsible_Document_RG_IssuingAuthority: 'SSP',
      setup_NumberOfChairs: params.accountType === 'J' ? params.setup_NumberOfChairs : 0,
      setup_DentistAdmin: true,
      setup_StandardAppointmentTime: 2,
      setup_WeeklyWorkingHours: 2,
      setup_WeekDays: 'MON,TER,WED,THU,FRI,SAT,SUN',
    };

    await new ClinicUseCase(`${ENDPOINT_CLINIC}`)
      .Post({
        data: model,
      })
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
            comeBack();
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
  };

  /**
   * comeBack - voltar
   */
  const comeBack = () => {
    navigate(PublicRoutes.LOGIN);
  };

  /**
   * endpoint de endereço
   */
  const ENDPOINT_ADDRESS = EndpointsConstant.address;

  /**
   * model endereco
   */
  const [endereco, setEndereco] = useState<null>(null);

  const getAddress = async (cep: string) => {
    await new AddressUseCase(`${ENDPOINT_ADDRESS}/${cep}`)
      .Get()
      .then((response) => {
        console.info('RESPONSE: ', response);
        setEndereco(response.body);
      })
      .catch((error) => {
        console.error('ERRO: ', error);
      });
  };

  return (
    <>
      <CriarClinicaPage addClinic={createClinic} comeBack={comeBack} getAddress={getAddress} address={endereco} />
    </>
  );
};
